import React, { useState, useEffect } from 'react';
import { getCompanySettings } from './api';
import './PrintInvoice.css';
import { formatDateDisplay, formatDateTimeDisplay } from '../utils/timezone';

const PrintInvoice = ({ workOrder }) => {
  const [companySettings, setCompanySettings] = useState({
    company_name: 'Paragon Wheel Repair',
    company_address: '123 Main Street',
    company_city: 'Your City, ST 12345',
    company_phone: '(555) 123-4567',
    company_email: 'info@paragonwheelrepair.com',
    company_logo_url: '',
    payment_terms: 'Payment is due upon receipt of this invoice.',
    invoice_footer_text: 'Thank you for your business!',
    invoice_contact_text: 'Questions? Contact us at (555) 123-4567 or email info@paragonwheelrepair.com',
  });

  const [invoiceNotes, setInvoiceNotes] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settings = await getCompanySettings();
        setCompanySettings(settings);
      } catch (error) {
        console.error('Error fetching company settings:', error);
        // Keep default settings if fetch fails
      }
    };
    fetchSettings();
  }, []);

  if (!workOrder) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return formatDateDisplay(dateString);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  const getPaymentMethodText = (method) => {
    switch (method) {
      case 'credit_card':
        return 'Credit Card';
      case 'check':
        return 'Check';
      default:
        return 'Check';
    }
  };

  return (
    <div className="print-invoice">
      <div className="invoice-header">
        <div className="company-address">
          <p>{companySettings.company_address}</p>
          <p>{companySettings.company_city}</p>
          <p>Phone: {companySettings.company_phone}</p>
        </div>
        
        <div className="company-logo-center">
          {companySettings.company_logo_url && (
            <img 
              src={companySettings.company_logo_url} 
              alt="Company Logo" 
              className="company-logo"
            />
          )}
        </div>
      </div>

      <div className="invoice-info-section">
        <div className="invoice-info-right">
          <div className="invoice-info-item">
            <span className="label">INVOICE #</span>
            <span className="value">{workOrder.invoice_number}</span>
          </div>
          <div className="invoice-info-item">
            <span className="label">DATE</span>
            <span className="value">{formatDate(workOrder.created_at)}</span>
          </div>
          <div className="invoice-info-item">
            <span className="label">DUE DATE</span>
            <span className="value">{formatDate(workOrder.date_promised)}</span>
          </div>
          <div className="invoice-info-item">
            <span className="label">TERMS</span>
            <span className="value">Due on receipt</span>
          </div>
        </div>
      </div>

      <div className="bottom-blue-line"></div>

      <div className="bill-to-section">
        <div className="bill-to">
          <h3>Bill To:</h3>
          <div className="customer-info">
            <p><strong>{workOrder.customer_name}</strong></p>
          </div>
        </div>
      </div>


      <div className="services-section">
        <table className="services-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                      <td>
                        <div className="service-description">
                          <p><strong>{workOrder.service_requested}</strong></p>
                          <p>Vehicle: {workOrder.vehicle}</p>
                          {workOrder.straightening && workOrder.straightening !== 'None' && (
                            <p>Straightening: {workOrder.straightening}</p>
                          )}
                        </div>
                      </td>
                      <td>{workOrder.number_of_wheels || 1}</td>
              <td>{formatCurrency(workOrder.price)}</td>
              <td>{formatCurrency(workOrder.price)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="totals-section">
        <div className="totals-table">
          <div className="total-row total-final">
            <span className="label"><strong>Total:</strong></span>
            <span className="value"><strong>{formatCurrency(workOrder.price)}</strong></span>
          </div>
        </div>
      </div>

      <div className="notes-section">
        <h3>Notes</h3>
        <textarea
          value={invoiceNotes}
          onChange={(e) => setInvoiceNotes(e.target.value)}
          className="notes-textarea"
        />
      </div>

      <div className="footer-section">
        <div className="payment-terms">
          <h4>Payment Terms</h4>
          <p>{companySettings.payment_terms}</p>
          <p>{companySettings.invoice_footer_text}</p>
        </div>
        <div className="contact-info">
          <p>{companySettings.invoice_contact_text}</p>
        </div>
      </div>
    </div>
  );
};

export default PrintInvoice;
